<template>
    <van-popup v-model="popupShow" position="bottom" :lazy-render="false">
        <div class="page bg-gray page-flex pb-fixed-btn">
            <appStatus :statusHeight="statusHeight"></appStatus>
            <div class="page-input-title" :style="{top:statusHeight+'rem'}">
                <div class="alifont icon-back left-icon click" @click="back"></div>
                <input type="search" @keyup.13="handleQuery" class="center-input fs-28" placeholder="搜索收货人姓名、手机号、订单号" v-model="pageInfo.queryKey">
                <div class="right fs-28 color-333 click" @click="handleQuery">
                    搜索
                </div>
            </div>
            <div class="tip-box" v-if="showTipBox">
                <div class="alifont icon-tongzhi"></div>
                <div class="flex1 fs-28 font-bold ml-20 mr-20">同一收货人多选可合并订单一格寄存</div>
                <div class="alifont icon-cha click" style="font-size: .32rem" @click="showTipBox = false;"></div>
            </div>
            <div class="posi-rel flex1 pd-025">
                <scroller ref="scroller" :on-refresh="loadNewData" :on-infinite="loadMore">
                    <div class="mt-20 person-order" v-for="(item,$index) in data" :key="$index">
                        <div class="order pd-250 click" v-for="(order,$orderIndex) in item.orderInfoVo" :key="$orderIndex" @click="chooseOrder(order)">
                            <div class="flex">
                                <div class="flex1 mr-20">
                                    <div class="fs-28 color-000" v-if="$orderIndex == 0">收货人：{{order.userName}}  <span class="ml-10">{{order.userMobile}}</span></div>
                                    <div class="mt-8 fs-24 color-999">订单号：{{order.orderNo}}</div>
                                </div>
                                <div class="choose-icon alifont " :class="chooseOrderIdArray.indexOf(order.orderId)>-1 ?'color-main icon-xuanzhong':'icon-weixuanzhong color-999'"></div>
                            </div>
                            <div class="product-list">
                                <div class="product-item" v-for="(prod,$prodIndex) in order.productList" :key="$prodIndex">
                                    <img :src="prod.imgPathView" alt="">
                                    <div class="numbers" v-if="prod.productQty > 1">{{prod.productQty}}件</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </scroller>
            </div>
            <div class="fixed-bot">
                <div class="btn click" @click="bindOrder()">确定</div>
            </div>
        </div>
    </van-popup>
</template>

<script>
    import initData from "@/mixins/initData"
    import appStatus from "@/components/appStatus/index"
    import getAppStatusHeight from "@/mixins/getAppStatusHeight";
    import {bindingZoneWayOrder2,bindingZoneWayOrder3} from "@/api/shop"
    import config from "@/config"
    export default {
        name: "waitOrderList",
        mixins: [initData,getAppStatusHeight],
        components:{appStatus},
        props:{
            orgId:{
                type: String,
                default:''
            },
            wayId:{
                type: String,
                default:''
            },
            orgLocation:{
                type: String,
                default:''
            },
        },
        data(){
            return{
                leftEle:{
                    iconName:'icon-back',
                    color:'#333',
                    fontSize:'.36rem',
                    method: this.back
                },
                popupShow:false,
                showTipBox: true,
                chooseOrderIdArray:[],
                chooseOrderArray:[],
                user:{},
                orderUserinfo:{},
                aliasName:this.$store.state.aliasName || config.projectName,
                shopZoneType: '0',    //寄存柜分区类型 0单用户 1多用户
            }
        },
        created() {
            this.popupShow = false;
        },
        methods:{
            back(){
                this.popupShow = false;
            },

            beforeInit() {
                this.params = { page : this.page, limit: this.limit};
                if(this.aliasName == 'yyagro'){
                    this.params.orgId = this.orgId
                }else{
                    this.params.lng = this.orgLocation.split(",")[0]
                    this.params.lat = this.orgLocation.split(",")[1]
                    this.params.orderTypeIn = '5,9,10'
                }
                this.url = 'order/orderBase/qryPageListByMap';
                let query = this.pageInfo;
                for (var key in query){
                    if(query[key]){
                        this.params[key] = query[key]
                    }
                }
                return true
            },

            //选择订单
            chooseOrder(order){
                console.log(this.shopZoneType)
                if(this.chooseOrderIdArray.indexOf(order.orderId) > -1 ){
                    this.chooseOrderIdArray.splice(this.chooseOrderIdArray.indexOf(order.orderId),1)
                    this.chooseOrderArray.splice(this.chooseOrderIdArray.indexOf(order.orderId),1)
                }else{
                    if(this.chooseOrderIdArray.length == 0){
                        this.chooseOrderIdArray.push(order.orderId);
                        this.chooseOrderArray.push(order);
                        if(this.shopZoneType != '1'){
                            this.orderUserinfo = {
                                userName: order.userName,
                                userMobile: order.userMobile
                            }
                        }
                    }else{
                        if(this.shopZoneType != '1'){
                            if(order.userMobile == this.orderUserinfo.userMobile){
                                this.chooseOrderIdArray.push(order.orderId);
                                this.chooseOrderArray.push(order);
                            }else{
                                this.$toast('不同收货人不能合并订单');
                                return
                            }
                        }else{
                            this.chooseOrderIdArray.push(order.orderId);
                            this.chooseOrderArray.push(order);
                        }

                    }
                }
            },

            bindOrder(){
                let params = {
                    orderIds:this.chooseOrderIdArray,
                    wayId: this.wayId,
                    orgId: this.orgId
                }
                let methodName;
                if(this.shopZoneType == '1'){
                    methodName = bindingZoneWayOrder3
                }else{
                    methodName = bindingZoneWayOrder2
                }
                methodName(params).then(res=>{
                    if(res.code == 0){
                        this.$toast("货道绑定订单成功");
                        this.popupShow = false;
                        this.chooseOrderIdArray = [];
                        this.chooseOrderArray = [];
                        this.orderUserinfo = {}
                        this.handleQuery();
                        this.$parent.getList();
                    }
                })
            }
        }
    }
</script>

<style scoped lang="scss">
    .tip-box{
        display: flex;
        align-items: center;
        height: .76rem;
        padding: 0 .24rem;
        color: #795605;
        background: #FFE3A2;
        .alifont{
            font-size: .4rem;
        }
    }
    .choose-icon{
        font-size: .44rem;
    }
    .product-list{
        display: flex;
        flex-wrap: wrap;
        padding-top: .14rem;
        .product-item{
            width: 1.26rem;
            height: 1.26rem;
            margin-left: .1rem;
            position: relative;
            margin-top: .1rem;
            .numbers{
                height: .32rem;
                width: 100%;
                line-height: .32rem;
                text-align: center;
                font-size: .22rem;
                color: #fff;
                position: absolute;
                left: 0;
                bottom: 0;
                background: rgba(0,0,0,.7);
            }
        }
    }
    .person-order{
        padding: 0 .24rem;
        background: #fff;
        border-radius: .12rem;
        .order{
            border-bottom: .1rem solid #F5F5F5;
            &:last-child{
                border-bottom: none;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// waitOrderList.vue?484c0a64